import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownProps {
  content: string;
  className?: string;
}

export function Markdown({ content, className = "" }: MarkdownProps) {
  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ children }) => <h2 className="mt-4 first:mt-0 text-base font-semibold leading-snug text-brand-950">{children}</h2>,
          h2: ({ children }) => <h3 className="mt-4 first:mt-0 text-[15px] font-semibold leading-snug text-brand-950">{children}</h3>,
          h3: ({ children }) => <h4 className="mt-4 first:mt-0 text-[14px] font-semibold leading-snug text-brand-950">{children}</h4>,
          p: ({ children }) => <p className="mt-3 first:mt-0 leading-relaxed">{children}</p>,
          ul: ({ children }) => <ul className="mt-3 list-disc space-y-1 pl-5">{children}</ul>,
          ol: ({ children }) => <ol className="mt-3 list-decimal space-y-1 pl-5">{children}</ol>,
          blockquote: ({ children }) => <blockquote className="mt-3 border-l-2 border-brand-200 pl-3 text-slate-600">{children}</blockquote>,
          code: ({ children, className }) => {
            const isBlock = className?.startsWith("language-");

            if (isBlock) {
              return <code className="text-slate-50">{children}</code>;
            }

            return <code className="rounded bg-slate-100 px-1 py-0.5 text-[0.92em] text-brand-950">{children}</code>;
          },
          pre: ({ children }) => <pre className="mt-3 overflow-x-auto rounded-md bg-slate-900 p-3 text-[12px] leading-relaxed text-slate-50">{children}</pre>,
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noreferrer" className="font-medium text-brand-700 underline underline-offset-2 hover:text-brand-600">
              {children}
            </a>
          ),
          table: ({ children }) => <div className="mt-3 overflow-x-auto"><table className="min-w-full text-left text-[12px]">{children}</table></div>,
          th: ({ children }) => <th className="border-b border-slate-200 px-2 py-1 font-semibold text-brand-950">{children}</th>,
          td: ({ children }) => <td className="border-b border-slate-100 px-2 py-1 align-top">{children}</td>,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
